import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { ScopedEntity } from '../../db/ScopedEntity.js';
import { CampusArea } from './CampusSection.js';

@Entity()
export class CampusEvent extends ScopedEntity {
  public static override _class = 'CampusEvent';
  public static override _collectionName = 'campus-events';

  public static override get allFields() {
    return selectionSet(() => this, 2);
  }

  @validate(nonOptional())
  @Field(type => String)
  public title: Maybe<string>;

  @Field(type => String, {
    default: v => v ?? CampusArea.STUDENTS,
  })
  public area: Maybe<string>;

  @validate(nonOptional())
  @Field(type => DateTime)
  public startDate: Maybe<DateTime>;

  @Field(type => DateTime)
  public endDate: Maybe<DateTime>;

  @Field(type => String)
  public description: Maybe<string>;

  @validate(({ value, key, source }) => {
    if (!value || value === '/') throw new ValidationError(`Dies ist ein Pflichtfeld!`, { key, source });
  })
  @Field(type => String, {
    default: v => v ?? '/',
  })
  public urlToEvent: Maybe<string>;

  @Field(type => String, {
    default: v => v ?? '/',
  })
  public urlToModeration: Maybe<string>;

  @Field(type => [Int], {
    default: v => v ?? [],
  })
  public forGrades!: number[];

  @Field(type => [String], {
    default: v => v ?? [],
  })
  public subjects!: string[];
}
